import { useEffect, useRef, useState } from 'react';
import { uploadStateAtom } from '@pixum/image-upload-service/lib/upload-state';
import type { DialogService } from '@pixum/types';
import { useImageStateStore } from 'stores/express-designer';
import { ExpressDesignerServiceClient } from 'services/express-designer';
import { invalidateImagesCacheAction } from '../actions/invalidateImagesCacheAction';
import { registerUploadErrorDialogs } from '../partials/upload-error/utils/registerUploadErrorDialogs';

interface UseExpressDesignerServiceParams {
  userId: string;
  constants: Record<string, string>;
}

export function useExpressDesignerService({ userId, constants }: UseExpressDesignerServiceParams) {
  const { updateImage, updateImages, changeUuid, removeImages } = useImageStateStore();
  const serviceRef = useRef<ExpressDesignerServiceClient | null>(null);
  const [dialogService, setDialogService] = useState<DialogService | null>(null);

  useEffect(() => {
    const client = new ExpressDesignerServiceClient(
      { updateImage, updateImages, changeUuid, removeImages },
      uploadStateAtom,
      async () => {
        useImageStateStore.getState().markBatchCompleted();
        const allImages = useImageStateStore.getState().images;
        const firstUploaded = allImages.find(img => img.isUpload && img.uuid);
        await invalidateImagesCacheAction({ userId, imageId: firstUploaded?.uuid });
      },
      constants
    );
    registerUploadErrorDialogs(client.dialogService);
    serviceRef.current = client;
    setDialogService(client.dialogService);
  }, []);

  return { serviceRef, dialogService };
}
